export default [
  {
    name: 'realname',
    path: '/realname',
    component: () => import(/* webpackChunkName: "realname" */ './index.vue')
  }
]
